// Login.vue
<template>
  <div class="d-flex justify-content-center align-items-center vh-100">
    <div class="card p-4 shadow" style="width: 350px;">
      <div class="card-body">
        <h3 class="text-center mb-3">Login</h3>
        <select v-model="selectedUser" class="form-control">
          <option value="1129566483">1129566483</option>
          <option value="22447508">22447508</option>
          <option value="32754129">32754129</option>
          <option value="22790794">22790794</option>
          <option value="1007682277">1007682277</option>
          <option value="18011746">18011746</option>
          <option value="52791976">52791976</option>
          <option value="1023892854">1023892854</option>
          <option value="1032398541">1032398541</option>
          <option value="52792600">52792600</option>
          <option value="52186790">52186790</option>
          <option value="39578318">39578318</option>
          <option value="32790569">32790569</option>
          <option value="63332091">63332091</option>
          <option value="31307246">31307246</option>
          <option value="14839971">14839971</option>
          <option value="1130593817">1130593817</option>
          <option value="1152187135">1152187135</option>
          <option value="75102594">75102594</option>
          <option value="43108653">43108653</option>
          <option value="43550191">43550191</option>
          <option value="79297243">79297243</option>
          <option value="1108642021">1108642021</option>
        </select>
        <button @click="login" class="btn btn-primary mt-3 w-100">Ingresar</button>
      </div>
    </div>
  </div>
</template>

<script>
import { trackEvent } from '../utils/analytics';

export default {
  data() {
    return {
      selectedUser: '',
      countdownInterval: null
    };
  },
  mounted() {
    const expirationTime = localStorage.getItem('expiration');
    if (expirationTime) {
      this.startCountdown(parseInt(expirationTime));
    }
  },
  methods: {
    login() {
      if (this.selectedUser) {
        const expirationTime = new Date().getTime() + 60 * 60 * 1000; // 60 minutos
        localStorage.setItem('user', this.selectedUser);
        localStorage.setItem('expiration', expirationTime);
        this.$emit('loginSuccess', this.selectedUser);
        this.startCountdown(expirationTime);

        // 🔹 Rastrear evento de login en Google Analytics
        trackEvent('login', 'authentication', `User: ${this.selectedUser}`);
      } else {
        alert('Seleccione un usuario');
      }
    },
    startCountdown(expirationTime) {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }
      this.countdownInterval = setInterval(() => {
        const now = new Date().getTime();
        const timeLeft = expirationTime - now;
        if (timeLeft > 0) {
          const minutes = Math.floor(timeLeft / 60000);
          const seconds = Math.floor((timeLeft % 60000) / 1000);
          console.clear();
          console.log(`Tiempo restante de sesión: ${minutes}m ${seconds}s`);
        } else {
          console.clear();
          console.log("La sesión ha expirado");
          clearInterval(this.countdownInterval);
          localStorage.removeItem('user');
          localStorage.removeItem('expiration');
        }
      }, 1000);
    }
  },
  watch: {
    selectedUser(newValue) {
      // 🔹 Rastrear cada opción seleccionada de forma individual
      const userLabelMap = {
        "1129566483": "User 1",
        "22447508": "User 2",
        "32754129": "User 3",
        "22790794": "User 4",
        "1007682277": "User 5",
        "18011746": "User 6",
        "52791976": "User 7",
        "1023892854": "User 8",
        "1032398541": "User 9",
        "52792600": "User 10",
        "52186790": "User 11",
        "39578318": "User 12",
        "32790569": "User 13",
        "63332091": "User 14",
        "31307246": "User 15",
        "14839971": "User 16",
        "1130593817": "User 17",
        "1152187135": "User 18",
        "75102594": "User 19",
        "43108653": "User 20"
      };

      const userLabel = userLabelMap[newValue] || `Unknown User (${newValue})`;

      // 🔹 Enviar evento a Google Analytics
      trackEvent('user_selection', 'dropdown', userLabel);
    }
  }
};
</script>

<style>
@import 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css';
</style>
